export const GetLocations = () => {

  return $.get('Location/GetLocations')

}


export const GetPoolsById = (locationId) => {

  return $.get('Pool/GetPools?locationId='+locationId)

}

export const AddLocation = (locationModel) => {

  return $.post('Location/AddLocation',locationModel)

}



export const UpdateLocation = (locationModel) => {

  return $.post('Location/UpdateLocation',locationModel)

}

export const AddPool = (poolModel) => {

  return $.post('Pool/AddPool',poolModel)

}


export const UpdatePool = (poolModel) => {

  return $.post('Pool/UpdatePool',poolModel)

}

export const DeletePool = (poolid) => {

  return $.post('Pool/DeletePool?poolId='+poolid)

}

export const DeleteLocation = (locationid) => {

  return $.post('Location/DeleteLocation?locationid='+locationid)

}

export const UpdateOrganization = (organizationModel) => {

  return $.post('Account/UpdateOrganization',organizationModel)

}

export const GetPositions = () => {

  return $.get('Position/GetPositions')

}


export const GetRoles = () => {

  return $.get('Position/GetRoles')

}

export const AddPosition = (positionModel) => {

  return $.post('Position/AddPosition',positionModel)

}

export const updateRole = (positionModel) => {

  return $.post('Position/UpdatePosition',positionModel)

}

export const DeletePosition = (positionid) => {

  return $.post('Position/DeletePosition?positionId='+positionid)

}



//certifications
export const GetCertificationTypes = () => {

    return $.get('Personnel/GetCertificationTypes')

  }

  export const AddCertificationType = (CertificationType) => {

      return $.post('Personnel/AddCertificationType',CertificationType)

    }


    export const DeleteCertificationType = (id) => {

        return $.post('Personnel/DeleteCertificationType?CertificationTypeId='+id)

      }
      export const UpdateCertificationType = (model) => {

        return $.post('Personnel/UpdateCertificationType',model)

        }

        //Disciplinary Actions

export const GetDisciplinaryActions = () => {

  return $.get('Personnel/GetDisciplinaryActions?IsActive='+true)

}

export const AddDisciplinaryAction = (model) => {

  return $.post('Personnel/AddDisciplinaryAction',model)

}


export const UpdateDisciplinaryAction = (model) => {

  return $.post('Personnel/UpdateDisciplinaryAction',model)

}
export const DeleteDisciplinaryAction = (Id) => {

  return $.post('Personnel/DeleteDisciplinaryAction?Id='+Id)

}



// WEBPACK FOOTER //
// ./src/pages/OrganizationDetails/OrganizationDetails.service.js